import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { NotificationCondition } from './nfs-condition';


@JsonObject('model.NotificationCondition')
export class NfsAlertCategory extends AbstractModel {

	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'title')
	title?: string;

	@JsonProperty([NotificationCondition], 'conditions')
  conditions?: NotificationCondition[];
}
